import AppRoutes from 'config/AppRoutes';

export default function getCurrentRoute(route: string) {
  if (
    route === AppRoutes.BILL_INFO ||
    route === AppRoutes.BILL_INFO_DEFAULT ||
    route === AppRoutes.SME_CONTACT
  )
    return AppRoutes.CONSUMPTION;
  // Find the key where the value is equal to the route
  const elem = Object.entries(AppRoutes).find(([_key, val]) => val === route);
  if (!elem) return route;
  return elem[1];
}
